/**
 * CRS (Common Reporting Standard) Tax Residency Country Configuration
 *
 * This file contains country code lists for managing CRS tax residency requirements.
 * CRS requires a specific set of countries that differs slightly from Griffin's supported
 * countries.
 *
 * TODO: [DETXOCOMPL-32] Remove this file once GriffinMetadataQuery is extended
 * This file contains hardcoded CRS country data as a temporary solution.
 * Once GriffinMetadataQuery provides the assigned country list, this file should be deleted.
 */

/**
 * CRS Tax Residency Country Codes not supported by Griffin (33 total)
 * These countries are required for CRS compliance but are not in Griffin's standard country list.
 * They will be mapped to country names using taxResidencyCountryList content keys.
 */
export const CRS_COUNTRIES_NOT_SUPPORTED_BY_GRIFFIN = [
  'AF', // Afghanistan
  'AS', // American Samoa
  'AX', // Åland Islands
  'BD', // Bangladesh
  'BL', // Saint Barthélemy
  'BQ', // Caribbean Netherlands
  'CF', // Central African Republic
  'CN', // China (Griffin uses C2)
  'CW', // Curaçao
  'GG', // Guernsey
  'GH', // Ghana
  'GQ', // Equatorial Guinea
  'GU', // Guam
  'HT', // Haiti
  'IM', // Isle of Man
  'IQ', // Iraq
  'JE', // Jersey
  'LB', // Lebanon
  'LR', // Liberia
  'LY', // Libya
  'MF', // Saint Martin
  'MM', // Myanmar
  'MO', // Macau
  'MP', // Northern Mariana Islands
  'PK', // Pakistan
  'PR', // Puerto Rico
  'PS', // Palestinian Territories
  'SD', // Sudan
  'SS', // South Sudan
  'SX', // Sint Maarten
  'TL', // Timor-Leste
  'UZ', // Uzbekistan
  'VI', // U.S. Virgin Islands
] as const;

/**
 * Griffin Country Codes NOT required for CRS Tax Residency (3 total)
 * These countries exist in Griffin's standard list but should be filtered out
 * when building the CRS tax residency country list.
 */
export const GRIFFIN_COUNTRIES_NOT_IN_CRS_LIST = [
  'AN', // Netherlands Antilles (deprecated country code)
  'C2', // China (Griffin uses C2, but CRS uses CN)
  'NF', // Norfolk Island (not required for CRS)
] as const;

/**
 * Type definitions for country codes
 */
export type CrsUnsupportedCountryCode =
  (typeof CRS_COUNTRIES_NOT_SUPPORTED_BY_GRIFFIN)[number];
export type GriffinExcludedCountryCode =
  (typeof GRIFFIN_COUNTRIES_NOT_IN_CRS_LIST)[number];
